/**
 * Types and factory functions for 3d axis-aligned bounding boxes (AABB3)
 * @module
 */

export interface AABB3 {
  minX: number;
  minY: number;
  minZ: number;

  maxX: number;
  maxY: number;
  maxZ: number;
}

export function aabb3New(minX: number, minY: number, minZ: number, maxX: number, maxY: number, maxZ: number): AABB3 {
  return { minX, minY, minZ, maxX, maxY, maxZ };
}
